import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumb = ({ items = [], testid = "breadcrumb" }) => (
  <nav data-testid={testid} aria-label="Breadcrumb" className="flex items-center flex-wrap gap-1.5 text-xs text-gray-500 mb-3">
    {items.map((it, i) => {
      const last = i === items.length - 1;
      return (
        <React.Fragment key={i}>
          {it.to && !last ? (
            <Link to={it.to} data-testid={`${testid}-link-${i}`}
              className="font-medium hover:text-[#A3E635] transition-colors">{it.label}</Link>
          ) : (
            <span data-testid={`${testid}-item-${i}`} aria-current={last ? "page" : undefined}
              className={last ? "text-gray-200 font-semibold" : "font-medium"}>{it.label}</span>
          )}
          {!last && <ChevronRight className="w-3 h-3 text-gray-600 shrink-0" />}
        </React.Fragment>
      );
    })}
  </nav>
);
